import { InputState as t } from "./components.js";
import { InputSystem as o } from "./systems.js";
const p = {
  systems: [o],
  components: {
    InputState: t
  }
};
export {
  p as InputPlugin
};
//# sourceMappingURL=plugin.js.map
